import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { ClassDetails } from '~entities/classes/modal/class';
import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface RotatePublicClassShareLinkResult {
  shareToken: string;
}

export const rotatePublicClassShareLinkAPI = async (params: {
  classId: string;
  regenerate: boolean;
}) => {
  const response = await baseAPI.post<RotatePublicClassShareLinkResult>(
    `/enrollments/${params.classId}/public-share-link`,
    { regenerate: params.regenerate },
  );
  return response.data;
};

export function useRotatePublicClassShareLink(classId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (regenerate: boolean) =>
      rotatePublicClassShareLinkAPI({ classId, regenerate }),
    onSuccess: (result) => {
      const shareToken =
        typeof result?.shareToken === 'string' ? result.shareToken.trim() : '';
      if (shareToken.length === 0) {
        return;
      }
      // Keep the token in the class + share-link query caches immediately.
      queryClient.setQueryData(
        [KEYS.CLASSES, classId],
        (previous: ClassDetails | undefined) => {
          if (previous == null) return previous;
          return { ...previous, publicClassShareToken: shareToken };
        },
      );
      queryClient.setQueryData([KEYS.CLASSES, classId, 'public-share-link'], {
        shareToken,
      });
    },
  });
}
